<template>
  <div style="width: 100%; min-height: 100vh; background: #f5f5f5">
    <div class="pageTop" style="position: fixed; top: 0; left: 0; right: 0; height: 46px; line-height: 46px; text-align: center; color: white; font-size: 18px; background: url(/img/counter/top-bg.webp) no-repeat #084ccb; z-index: 1000;">
      <img src="/static/image/nav_chevron_back.bb0f0ac706614ab578365b31d203927a.png" alt="" style="width: 16px; height: 16px; position: absolute; left: 15px; top: 50%; transform: translateY(-50%); cursor: pointer;" @click="$router.back()" />
      {{ $t('financial_report') }}
    </div>
    <div style="height: 46px"></div>
    
    <!-- 日期筛选 -->
    <div class="date-filter" style="display: flex; justify-content: space-between; margin: 10px; padding: 0 5px;">
      <div 
        v-for="(date, index) in dateOptions" 
        :key="index" 
        class="date-item" 
        :class="{ active: selectedDate === date.value }" 
        @click="selectDate(date.value)"
        style="flex: 1; text-align: center; padding: 8px 0; font-size: 14px; border-radius: 16px; cursor: pointer; margin: 0 5px;"
      >
        {{ date.label }}
      </div>
    </div>

    <!-- 数据卡片 -->
    <div class="data-cards" style="padding: 0 10px;">
      <div class="card-row" style="display: flex; justify-content: space-between; margin-bottom: 10px;">
        <div class="data-card" style="flex: 1; background-color: #fff; border-radius: 10px; padding: 15px; margin: 0 5px; text-align: center;">
          <div class="card-label" style="font-size: 14px; color: #666; margin-bottom: 10px;">{{ $t('recharge') }}</div>
          <div class="card-value" style="font-size: 18px; font-weight: bold;">{{ formatNumber(reportData.recharge) }}</div>
        </div>
        <div class="data-card" style="flex: 1; background-color: #fff; border-radius: 10px; padding: 15px; margin: 0 5px; text-align: center;">
          <div class="card-label" style="font-size: 14px; color: #666; margin-bottom: 10px;">{{ $t('withdrawal') }}</div>
          <div class="card-value" style="font-size: 18px; font-weight: bold;">{{ formatNumber(reportData.withdrawal) }}</div>
        </div>
      </div>
      
      <div class="card-row" style="display: flex; justify-content: space-between; margin-bottom: 10px;">
        <div class="data-card" style="flex: 1; background-color: #fff; border-radius: 10px; padding: 15px; margin: 0 5px; text-align: center;">
          <div class="card-label" style="font-size: 14px; color: #666; margin-bottom: 10px;">{{ $t('bet_amount') }}</div>
          <div class="card-value" style="font-size: 18px; font-weight: bold;">{{ formatNumber(reportData.betAmount) }}</div>
        </div>
        <div class="data-card" style="flex: 1; background-color: #fff; border-radius: 10px; padding: 15px; margin: 0 5px; text-align: center;">
          <div class="card-label" style="font-size: 14px; color: #666; margin-bottom: 10px;">{{ $t('valid_bet') }}</div>
          <div class="card-value" style="font-size: 18px; font-weight: bold;">{{ formatNumber(reportData.validBet) }}</div>
        </div>
      </div>
      
      <div class="card-row" style="display: flex; justify-content: space-between; margin-bottom: 10px;">
        <div class="data-card" style="flex: 1; background-color: #fff; border-radius: 10px; padding: 15px; margin: 0 5px; text-align: center;">
          <div class="card-label" style="font-size: 14px; color: #666; margin-bottom: 10px;">{{ $t('game_rebate') }}</div>
          <div class="card-value" style="font-size: 18px; font-weight: bold;">{{ formatNumber(reportData.gameRebate) }}</div>
        </div>
        <div class="data-card" style="flex: 1; background-color: #fff; border-radius: 10px; padding: 15px; margin: 0 5px; text-align: center;">
          <div class="card-label" style="font-size: 14px; color: #666; margin-bottom: 10px;">{{ $t('agent_commission') }}</div>
          <div class="card-value" style="font-size: 18px; font-weight: bold;">{{ formatNumber(reportData.agentCommission) }}</div>
        </div>
      </div>
      
      <div class="card-row" style="display: flex; justify-content: space-between; margin-bottom: 10px;">
        <div class="data-card" style="flex: 1; background-color: #fff; border-radius: 10px; padding: 15px; margin: 0 5px; text-align: center;">
          <div class="card-label" style="font-size: 14px; color: #666; margin-bottom: 10px;">{{ $t('activity_bonus') }}</div>
          <div class="card-value" style="font-size: 18px; font-weight: bold;">{{ formatNumber(reportData.activityBonus) }}</div>
        </div>
      </div>
      
      <div class="card-row" style="display: flex; justify-content: space-between; margin-bottom: 10px;">
        <div class="data-card" style="flex: 1; background-color: #fff; border-radius: 10px; padding: 15px; margin: 0 5px; text-align: center;">
          <div class="card-label" style="font-size: 14px; color: #666; margin-bottom: 10px;">{{ $t('game_win_loss') }}</div>
          <div class="card-value" :style="{ color: (reportData.gameWinLoss || 0) >= 0 ? '#ff4d4f' : '#52c41a' }" style="font-size: 18px; font-weight: bold;">
            {{ formatNumber(reportData.gameWinLoss) }}
          </div>
        </div>
        <div class="data-card" style="flex: 1; background-color: #fff; border-radius: 10px; padding: 15px; margin: 0 5px; text-align: center;">
          <div class="card-label" style="font-size: 14px; color: #666; margin-bottom: 10px;">{{ $t('net_win_loss') }}</div>
          <div class="card-value" :style="{ color: (reportData.netWinLoss || 0) >= 0 ? '#ff4d4f' : '#52c41a' }" style="font-size: 18px; font-weight: bold;">
            {{ formatNumber(reportData.netWinLoss) }}
          </div>
        </div>
      </div>
    </div>

    <!-- 提示信息 -->
    <div class="tip-message" style="margin: 20px 10px; padding: 10px; background-color: #fff; border-radius: 10px; font-size: 12px; color: #666;">
      <span style="color: #ff4d4f; margin-right: 5px;">①</span>
      {{ $t('tip_message') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'userCent',
  data() {
    return {
      dateOptions: [
        { label: '', value: 'today' },
        { label: '', value: 'yesterday' },
        { label: '', value: 'week' },
        { label: '', value: 'lastWeek' }
      ],
      selectedDate: 'today',
      reportData: {
        recharge: 0,
        withdrawal: 0,
        betAmount: 0,
        validBet: 0,
        gameRebate: 0,
        agentCommission: 0,
        texasInsurance: 0,
        activityBonus: 0,
        gameWinLoss: 0,
        netWinLoss: 0
      }
    };
  },
  created() {
    // 初始化多语言标签
    this.dateOptions = [
      { label: this.$t('today'), value: 'today' },
      { label: this.$t('yesterday'), value: 'yesterday' },
      { label: this.$t('this_week'), value: 'week' },
      { label: this.$t('last_week'), value: 'lastWeek' }
    ];
    this.getData();
  },
  methods: {
    formatNumber(value) {
      if (value === undefined || value === null) return '0.00';
      return Number(value).toFixed(2);
    },
    selectDate(date) {
      this.selectedDate = date;
      this.getData();
    },
    getData() {
      let that = this;
      let params = {
        start_date: '',
        end_date: ''
      };

      const today = new Date();
      if (that.selectedDate === 'today') {
        params.start_date = today.toISOString().split('T')[0];
        params.end_date = today.toISOString().split('T')[0];
      } else if (that.selectedDate === 'yesterday') {
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        params.start_date = yesterday.toISOString().split('T')[0];
        params.end_date = yesterday.toISOString().split('T')[0];
      } else if (that.selectedDate === 'week') {
        const weekStart = new Date(today);
        weekStart.setDate(today.getDate() - today.getDay());
        params.start_date = weekStart.toISOString().split('T')[0];
        params.end_date = today.toISOString().split('T')[0];
      } else if (that.selectedDate === 'lastWeek') {
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7);
        const lastWeekEnd = new Date(today);
        lastWeekEnd.setDate(today.getDate() - today.getDay() - 1);
        params.start_date = lastWeekStart.toISOString().split('T')[0];
        params.end_date = lastWeekEnd.toISOString().split('T')[0];
      }

      // 同时调用两个接口，并传递时间参数给 performance 接口
      Promise.all([
        this.$apiFun.post("/api/financeReport", params),
        this.$apiFun.get("/api/team/performance", { 
          params: { 
            start: params.start_date, 
            end: params.end_date 
          } 
        })
      ]).then(([reportRes, perfRes]) => {
        console.log('财务报告返回:', reportRes);
        console.log('业绩统计返回:', perfRes);
        
        if (reportRes.code === 200) {
          that.reportData = {
            recharge: reportRes.data.recharge || 0,
            withdrawal: reportRes.data.withdrawal || 0,
            betAmount: reportRes.data.betAmount || 0,
            validBet: reportRes.data.validBet || 0,
            gameRebate: reportRes.data.gameRebate || 0,
            // 从 performance 接口获取对应时间段的佣金
            agentCommission: (perfRes.code === 200 && perfRes.data) ? (perfRes.data.total_commission || 0) : 0,
            texasInsurance: reportRes.data.texasInsurance || 0,
            activityBonus: reportRes.data.activityBonus || 0,
            gameWinLoss: reportRes.data.gameWinLoss || 0,
            netWinLoss: reportRes.data.netWinLoss || 0
          };
          console.log('当前时间段佣金:', that.reportData.agentCommission);
        }
      }).catch(err => {
        console.log('获取数据失败:', err);
        that.reportData = {
          recharge: 0,
          withdrawal: 0,
          betAmount: 0,
          validBet: 0,
          gameRebate: 0,
          agentCommission: 0,
          texasInsurance: 0,
          activityBonus: 0,
          gameWinLoss: 0,
          netWinLoss: 0
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.date-filter {
  .date-item {
    background-color: #fff;
    transition: all 0.3s;
    
    &.active {
      background-color: #084ccb;
      color: white;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/userCent.vue